import React from 'react';
import { Box, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Hero from '../../../components/ui/Hero';

export default function ServiciosHero() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        pt: { xs: 12, lg: 16 },
        pb: { xs: 8, lg: 10 },
        overflow: 'hidden',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#f8fafc',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-20%',
          right: '-10%',
          width: '800px',
          height: '800px',
          borderRadius: '50%',
          bgcolor: 'rgba(25, 118, 210, 0.05)',
          filter: 'blur(120px)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-20%',
          left: '-10%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          bgcolor: 'rgba(2dc2d1, 0.05)',
          filter: 'blur(100px)',
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 10 }}>
        <Hero t={t} prefix="pages.servicios" />
      </Container>
    </Box>
  );
}
